import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

const FileUploadError = ({
  uploadFiles,
  field,
  uploadError,
  setupdateChild,
  updateChild,
}) => {
  const {t} = useTranslation();
  const [reFreshFlag] = useState(false);

  useEffect(() => {
    setupdateChild(!reFreshFlag);
  }, [updateChild]);

  return (
    <>
      {(uploadFiles || []).find((u) => {
        return u?.qid == field?.name?.replace('_', '');
      }) ? (
        <></>
      ) : !uploadFiles?.length && uploadError ? (
        <span className="text-danger text-right input-error-msg">
          {t('Required')}
        </span>
      ) : uploadFiles?.length &&
        !(uploadFiles || []).find((u) => {
          return u?.qid == field?.name?.replace('_', '');
        }) ? (
        <span className="text-danger text-right input-error-msg">
          {t('Required')}
        </span>
      ) : (
        <></>
      )}
    </>
  );
};

export default FileUploadError;
